// extracted by mini-css-extract-plugin
export default {"error":"InputPage_error__nLVwr","name":"InputPage_name__O6vG4","pulse3":"InputPage_pulse3__k-1I5","email":"InputPage_email__cT-IF","label":"InputPage_label__1jnGz"};